const selectors = {
  section: '[data-brand-carousel-section]',
  slider: '[data-brand-carousel-slider]',
};

function getFlickity() {
  return (window.theme && window.theme.Flickity) || window.Flickity || null;
}

function parseConfig(slider) {
  const raw = slider.getAttribute('data-flickity-config') || '{}';
  try {
    return JSON.parse(raw);
  } catch (e) {
    console.warn('Invalid Flickity config', e);
    return {};
  }
}

function getGroupCells(section) {
  const style = getComputedStyle(section);
  const w = window.innerWidth;
  if (w <= 767) return parseInt(style.getPropertyValue('--brand-carousel-cards-mobile').trim()) || 1;
  if (w <= 1024) return parseInt(style.getPropertyValue('--brand-carousel-cards-tablet').trim()) || 3;
  return parseInt(style.getPropertyValue('--brand-carousel-cards-desktop').trim()) || 4;
}

function initBrandCarousel(section) {
  const slider = section.querySelector(selectors.slider);
  const FlickityLib = getFlickity();

  if (!slider || slider.dataset.flickityBound === 'true' || !FlickityLib) return;

  const config = parseConfig(slider);
  config.groupCells = getGroupCells(section);

  const flkty = new FlickityLib(slider, config);
  slider.dataset.flickityBound = 'true';
  slider.__flkty = flkty;

  let resizeTimeout;
  const onResize = () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      flkty.options.groupCells = getGroupCells(section);
      flkty.resize();
    }, 250);
  };
  window.addEventListener('resize', onResize);
  slider.__flktyResizeHandler = onResize;
}

function destroySlider(section) {
  const slider = section.querySelector(selectors.slider);
  if (slider && slider.__flkty) {
    if (slider.__flktyResizeHandler) {
      window.removeEventListener('resize', slider.__flktyResizeHandler);
      delete slider.__flktyResizeHandler;
    }
    slider.__flkty.destroy();
    delete slider.__flkty;
    slider.dataset.flickityBound = 'false';
  }
}

function initAllBrandCarousels() {
  document.querySelectorAll(selectors.section).forEach(initBrandCarousel);
}

document.addEventListener('DOMContentLoaded', initAllBrandCarousels);

document.addEventListener('shopify:section:load', (event) => {
  if (event.target.matches(selectors.section)) {
    initBrandCarousel(event.target);
  } else {
    event.target.querySelectorAll(selectors.section).forEach(initBrandCarousel);
  }
});

document.addEventListener('shopify:section:unload', (event) => {
  if (event.target.matches(selectors.section)) {
    destroySlider(event.target);
  } else {
    event.target.querySelectorAll(selectors.section).forEach(destroySlider);
  }
});

